import React, { useEffect, useRef } from 'react';
import { motion, useInView, useAnimation } from 'framer-motion';

//  @desc  Last Animation
export const DelayedWrapper = ({ children }) => {
  const delayedRef = useRef(null);
  const isInView = useInView(delayedRef, { once: true });

  const mainControls = useAnimation();

  const animationVariant = {
    hidden: { opacity: 0, y: 75 },
    visible: { opacity: 1, y: 0 },
  };

  useEffect(() => {
    if (isInView) {
      mainControls.start('visible');
    }
  }, [isInView, mainControls]);

  return (
    <div ref={delayedRef} style={{ position: 'relative', overflow: 'hidden' }}>
      <motion.div
        variants={animationVariant}
        initial='hidden'
        animate={mainControls}
        transition={{ duration: 0.8, delay: 0.82 }}
      >
        {children}
      </motion.div>
    </div>
  );
};
